import { Box, Text } from "theme-ui";

import * as styles from "./PersonalizationName.styles";

export default function PersonalizationName({
  playerName,
  playerNumber,
  engineeredFor,
}) {
  return (
    <Box sx={styles.personalizationName}>
      <Box sx={styles.personalizationNameInner}>
        {playerName && <Text sx={styles.name}>{playerName}</Text>}
        {playerNumber && <Text sx={styles.number}>{playerNumber}</Text>}
        {engineeredFor && (
          <Text sx={styles.engineeredFor}>{engineeredFor}</Text>
        )}
      </Box>
    </Box>
  );
}
